import React from 'react';
import { withTheme } from 'styled-components';

import { LegendGroup, LegendItem, Circle, LegendLabel } from './styles';

function Legend({ theme }) {
  return (
    <LegendGroup>
      <LegendItem>
        <Circle color={`${theme.brand.primary}`} />
        <LegendLabel>Pushes</LegendLabel>
      </LegendItem>
      <LegendItem>
        <Circle color={`${theme.brand.secondary}`} />
        <LegendLabel>Pulls</LegendLabel>
      </LegendItem>
    </LegendGroup>
  );
}

export default withTheme(Legend);
